import type { FeatureManifest } from '../registry.js';

/** CP-01 weekly league (SCR-11) and the results card on the next app open. */
export default {
  id: 'league',
  unlock: 'league',
  flag: 'league',
  online: true,
  art: ['league'],
  provides: ['league', 'leagueResult'],
  entry: { order: 2, icon: 'trophy', label: 'rail.league', testId: 'rail-league', open: 'league' },
  mapOrder: 20,
  mapDue: (a) => a.services.sync.status !== 'offline' && !a.session.checked.has('league'),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
